import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchAllCCMData = async (filter) => {
  const {
    account_id, 
    location_id,
    page,
    per_page,
    search_term,
    order_by
  } = filter;
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    try {
      const response = await axios.get(
        `${Config.apiServerUrl}/ccm/get-all?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${orderBy}`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
  
      return response;
    }  catch (error) {
      if (error.response?.status === 404) {
        return "Never";
      }
  
      console.error("Error fetching last updated time:", error);
      return {
        error: true,
        message: error.response?.data?.message || "An error occurred while fetching all ccm data.",
      };
    }
  };

